import type { LabelPrintMarginSettings } from "@itaas/label-print";
import { useState } from "react";

interface LabelMarginControlProps {
  margins: LabelPrintMarginSettings;
  showRollFields: boolean;
  onChange: (patch: Partial<LabelPrintMarginSettings>) => void;
  onSaveProfile?: () => void;
  savingProfile?: boolean;
}

function numValue(value: number | undefined): string {
  return value == null ? "" : String(value);
}

function parseNum(raw: string): number | undefined {
  const trimmed = raw.trim();
  if (!trimmed) return undefined;
  const n = Number(trimmed);
  return Number.isFinite(n) ? n : undefined;
}

export function LabelMarginControl({
  margins,
  showRollFields,
  onChange,
  onSaveProfile,
  savingProfile,
}: LabelMarginControlProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="ph-label-margin-control">
      <button
        type="button"
        className="btn btn-link btn-sm p-0 text-start"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {open ? "▾" : "▸"} Marges avancées (mm)
      </button>
      {open && (
        <div className="border rounded p-2 mt-1 bg-white">
          <div className="row g-2">
            <div className="col-6 col-md-4">
              <label className="form-label small mb-0">Marge gauche</label>
              <input
                type="number"
                step="0.5"
                min="0"
                className="form-control form-control-sm"
                value={numValue(margins.marginLeftMm)}
                onChange={(e) => onChange({ marginLeftMm: parseNum(e.target.value) })}
                placeholder="auto"
              />
            </div>
            <div className="col-6 col-md-4">
              <label className="form-label small mb-0">Marge haut / en-tête</label>
              <input
                type="number"
                step="0.5"
                min="0"
                className="form-control form-control-sm"
                value={numValue(margins.marginTopMm)}
                onChange={(e) => onChange({ marginTopMm: parseNum(e.target.value) })}
                placeholder="auto"
              />
            </div>
            <div className="col-6 col-md-4">
              <label className="form-label small mb-0">Zone en-tête</label>
              <input
                type="number"
                step="0.5"
                min="0"
                className="form-control form-control-sm"
                value={numValue(margins.brandZoneMm)}
                onChange={(e) => onChange({ brandZoneMm: parseNum(e.target.value) })}
                placeholder="auto"
              />
            </div>
            {showRollFields && (
              <>
                <div className="col-6 col-md-4">
                  <label className="form-label small mb-0">Largeur rouleau</label>
                  <input
                    type="number"
                    step="1"
                    min="0"
                    className="form-control form-control-sm"
                    value={numValue(margins.rollWidthMm)}
                    onChange={(e) => onChange({ rollWidthMm: parseNum(e.target.value) })}
                    placeholder="auto"
                  />
                </div>
                <div className="col-6 col-md-4">
                  <label className="form-label small mb-0">Facteur horizontal</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="1"
                    className="form-control form-control-sm"
                    value={numValue(margins.rollOffsetFactor)}
                    onChange={(e) => onChange({ rollOffsetFactor: parseNum(e.target.value) })}
                    placeholder="auto"
                  />
                </div>
              </>
            )}
          </div>
          {onSaveProfile && (
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm mt-2"
              disabled={savingProfile}
              onClick={onSaveProfile}
            >
              {savingProfile ? "Enregistrement…" : "Enregistrer pour cette imprimante"}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
